/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, value: NonNullable<unknown> }} Exercise_Sheet_Chart_PointInputs */

const en_us2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

const pt_br2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

const es_419_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

const pt_pt2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

const fr_fr2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : ${i?.value}`)
};

const de_de2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

const it_it2_exercise_sheet_chart_point = /** @type {(inputs: Exercise_Sheet_Chart_PointInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{day}: {value}" |
*
* @param {Exercise_Sheet_Chart_PointInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_chart_point = /** @type {((inputs: Exercise_Sheet_Chart_PointInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Chart_PointInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_chart_point(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_chart_point(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_chart_point(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_chart_point(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_chart_point(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_chart_point(inputs)
	return en_us2_exercise_sheet_chart_point(inputs)
});
export { exercise_sheet_chart_point as "exercise-sheet.chart_point" }